import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const CreateAudits = lazy(() => import('./CreateAudits'))
const AuditSectionAndQuestions = lazy(() => import('./AuditSectionAndQuestions'))
const MyAssignedAudits = lazy(() => import('./MyAssignedAudits'))
const AuditAnswers = lazy(() => import('./AuditAnswers'))
const AuditAnswersView = lazy(() => import('./AuditAnswersView'))
const AllAudits = lazy(() => import('./AllAudits'))
const NewAllAssignAuditView = lazy(() => import('./NewAllAssignAuditView'))
const NewBasicDetails = lazy(() => import('./NewBasicDetails'))
const AuditsRoutes = [
    {
        path: '/create_audit',
        component: CreateAudits,
        auth: authRoleAccess.audit_create,
    },
    {
        path: '/audits',
        component: AllAudits,
        auth: authRoleAccess.audit_create,
    },
    {
        path: '/audit_section/:id',
        component: AuditSectionAndQuestions,
        auth: authRoleAccess.audit_create,
    },
    {
        path: '/my_audits',
        component: MyAssignedAudits,
        auth: authRoleAccess.my_audits,
    },
    {
        path: '/audit_answering/:id',
        component: AuditAnswers,
        auth: authRoleAccess.audit_answers_given,
    },
    {
        path: '/audit_answer_view/:id',
        component: NewBasicDetails,
        auth: authRoleAccess.audit_create,
    },
    {
        path: '/NewAllAssignAuditView',
        component: NewAllAssignAuditView,
        auth: authRoleAccess.audit_create,
    },

]

export default AuditsRoutes 